import React from 'react';

export const ThankYou = () => {
  return (
    <div>Thank you for your message.</div>
  )
}